import { Component } from '@nicolas-riciotti/light2';
import {isMobilePortrait} from '../../helpers/isMobile';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition';
import BezierEasing from '../../helpers/BezierEasing.js'

const easing = BezierEasing(0.23, 1, 0.32, 1);

export default class BlockLocations extends Component {

    created() {
        this.siteSettingsMotionChange = this.siteSettingsMotionChange.bind(this);
        this.onScroll = this.onScroll.bind(this); 
        this._scroll = 0;
        this.stopped = false;
    }

    siteSettingsMotionChange(event) {
        this.stopped = ('off' === event.detail);
    }

    attached() {

        document.addEventListener('site_settings_motion', this.siteSettingsMotionChange, false);

        this.$slidescontainer = this.querySelector('[data-slides-container]');
        this.$contentContainer = this.querySelector('[data-content-container]');
        this.$slides = this.querySelectorAll('[data-slide');

        if (window.innerWidth <= 600) {
            return;
        }

        this.$slides?.forEach(el => {
            const $title = el.querySelector('[data-slide-title]');
            $title.style.marginLeft = '-0.2em';
            
            // Split text into characters and handle kerning for problematic pairs
            const text = $title?.innerHTML.trim();
            let html = '';

            $title.setAttribute('aria-label', text);
            
            for (let i = 0; i < text.length; i++) {
                const currentChar = text[i];
                const nextChar = text[i + 1] || '';
                
                // Determine margin adjustment based on character pairs
                let marginRight = '-0.2em'; // default
                
                // Check for problematic kerning pairs
                if (currentChar === 'Y' && 'aeou'.includes(nextChar.toLowerCase())) {
                    marginRight = '-0.28em'; // Tighter spacing after Y
                } else if (currentChar === 'T' && 'aeou'.includes(nextChar.toLowerCase())) {
                    marginRight = '-0.26em';
                } else if (currentChar === 'W' && 'aeou'.includes(nextChar.toLowerCase())) {
                    marginRight = '-0.24em';
                } else if (currentChar === 'V' && 'aeou'.includes(nextChar.toLowerCase())) {
                    marginRight = '-0.25em';
                }
                
                const displayChar = currentChar === ' ' ? '&nbsp;' : currentChar;
                html += `<span aria-hidden="true" letter style="overflow:hidden;display:inline-block;padding:0.1em;margin-right:${marginRight};"><span letter-inner style="display: inline-block;">${displayChar}</span></span>`;
            }
            
            $title.innerHTML = html;
        });
        this.resize();
        Lenis?.on?.('scroll', this.onScroll);
    }

    resize() {
    }
    
    onScroll(e) {

        if (window.innerWidth <= 600) {
            return;
        }

        this._scroll = e.animatedScroll ;

        this.querySelector('[data-locations-header]').style.marginBottom = this.stopped ? '0' : '-25vh';

        this.style.marginBottom =  this.stopped ? '0' : '50vh';

        this.$slides?.forEach((slideEl, slideIndex) => {

            const slidePos = getPosition(slideEl);
            
            const $title  = slideEl.querySelector('[data-slide-title]');
            const $text   = slideEl.querySelector('[data-slide-text]');
            const $image  = slideEl.querySelector('[data-slide-image]');
            const $button = slideEl.querySelector('[data-slide-button]');
            
            slideEl.style.marginBottom =  this.stopped ? '0' : '100vh';
            
            if (this.stopped) {
                
                slideEl.querySelector('[data-slide-inner]').style.position = 'absolute';
                $title.style.opacity  = 1;
                $text.style.opacity   = 1;
                $image.style.opacity  = 1;
                $button.style.opacity  = 1;
                $title.style.transform  = 'none';
                $text.style.transform   = 'none';
                $image.style.transform  = 'none';
                $button.style.transform  = 'none';
                $button.style.pointerEvents = 'auto';

                $title.querySelectorAll('[letter-inner]')?.forEach((l,li) => {
                    l.style.transform = `translateY(0%)`;
                    l.style.opacity = 1;
                });

            }
            else {

                slideEl.querySelector('[data-slide-inner]').style.position = 'fixed';
                $title.style.opacity  = 0
                $text.style.opacity   = 0
                $image.style.opacity  = 0
    
                {
                    const diff2 = (this._scroll - slidePos.top + (window.innerHeight * 0.5));// * -0.2
                    const e = easing(Math.min(1, Math.max(0, diff2 / (window.innerHeight * 2))));
                    const diff3 = (this._scroll - slidePos.top + (window.innerHeight * 0.5) - (window.innerHeight * 0.5));// * -0.2
                    const e2 = 1 - easing(1 - Math.min(1, Math.max(0, diff3 / (window.innerHeight * 2))));
                    $image.style.opacity = e;
                    const s = 1.8 - 0.8 * e;
                    $image.style.transform = `translate3d(0,${((1 - e) * (window.innerHeight) + (e2 * window.innerHeight * -1))}px,0) scale(${s})`;
                    $text.style.transform = `translate3d(0,${((1 - e) * (window.innerHeight) + (e2 * window.innerHeight * -1))}px,0)`;
                    $button.style.transform = `translate3d(0,${((1 - e) * (window.innerHeight) + (e2 * window.innerHeight * -1))}px,0)`;
                }
    
                {
                    const diff2 = (this._scroll - slidePos.top + (window.innerHeight * 0.5));// * -0.2
                    const e = easing(Math.min(1, Math.max(0, diff2 / (window.innerHeight * 2))));
                    const diff3 = (this._scroll - slidePos.top + (window.innerHeight * 0.5) - (window.innerHeight * 0.5));// * -0.2
                    const e2 = 1 - easing(1 - Math.min(1, Math.max(0, diff3 / (window.innerHeight * 2))));
                    $title.style.opacity = 1;
                    const s = 1.6 - 0.6 * e;
                    $title.style.transform = `translate3d(0,${((1 - e) * (window.innerHeight * 1.5) + (e2 * window.innerHeight * 1.25 * -1))}px,0) scale(${s})`;
                    $title.querySelectorAll('[letter-inner]')?.forEach((l,li) => {
                        const diff2 = (this._scroll - slidePos.top + (window.innerHeight * 0.5 - window.innerHeight * 0.05 * li));// * -0.2
                        const e = easing(Math.min(1, Math.max(0, diff2 / (window.innerHeight))));
                        l.style.transform = `translateY(${((1 - e) * 100)}%)`;
                        l.style.opacity = 1;
                    });
                }
    
                {
                    const diff2 = (this._scroll - slidePos.top + (- window.innerHeight * 0.5));// * -0.2
                    const e = easing(Math.min(1, Math.max(0, diff2 / (window.innerHeight * 1.5))));
                    $text.style.opacity = e;
                    $button.style.opacity = e;
                    $button.style.pointerEvents = e > 0 ? 'auto' : 'none';

                }

            }

        });
    }

}

customElements.define('block-locations', BlockLocations);